export default "__VITE_ASSET__C2$_1ExX__"